<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{route.menuName}}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="no" label="系统自动生成申请单号">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="createdUserName" label="创建人">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="ownerDeptName" label="所属科室">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="申请人" prop="userName">
                <el-select :disabled="!editMode" v-model="form.userName" style="width: 90%" filterable placeholder="请选择申请人" :filter-method="getUsers" @change="applyUserChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>

            </el-col>
            <el-col :span="6">
              <el-form-item label="申请科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="系统自动带出申请科室" :filter-method="getDepts" @change="applyDeptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="联系电话" prop="phone">
                <el-input :disabled="!editMode" placeholder="系统自动带出联系电话" v-model="form.phone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="date" label="申报日期">
                <el-date-picker :disabled="!editMode" v-model="form.date" size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="申报日期" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="type" label="申请类型">
                <!-- <el-radio-group :disabled="!editMode" v-model="form.type">
                  <el-radio v-for="item in ChooseProductOptions" :key="item.id" :label="item.id">{{item.name}}</el-radio>
                </el-radio-group> -->
                <el-select v-model="form.type" :disabled="!editMode " style="width: 100%">
                  <el-option v-for="item in ChooseProductOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="isNewTechnique" label="是否涉及新技术">
                <!-- <el-radio-group :disabled="!editMode" v-model="form.isNewTechnique">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group> -->
                <el-select v-model="form.isNewTechnique" :disabled="!editMode " style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新技术名称" prop="newTechniqueName">
                <el-input :disabled="!editMode" placeholder="新技术名称" v-model="form.newTechniqueName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="产品名称" prop="productName">
                <el-input :disabled="!editMode" placeholder="请填写注册证名称" v-model="form.productName"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input :disabled="!editMode" placeholder="规格型号" v-model="form.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-input :disabled="!editMode" placeholder="生产厂家" v-model="form.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="注册证号" prop="registNo">
                <el-input :disabled="!editMode" placeholder="注册证号" v-model="form.registNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="form.number" :min="0" :controls="false" placeholder="数量" style="width: 100%" @change="autoAmount"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="price" label="预计单价">
                <el-input-number :disabled="!editMode" :controls="false" style="width: 100%" placeholder="挂网产品请填写挂网价格;非挂网产品填写市场平均价格" v-model="form.price" @change="autoAmount"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="amount" label="预计金额">
                <el-input-number disabled :controls="false" style="width: 100%" placeholder="请输入预计金额" v-model="form.amount"></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否收费" prop="isCharge">
                <el-select v-model="form.isCharge" :disabled="!editMode && !showWorkFlowInfo" style="width: 100%">
                  <el-option v-for="item in WhetherOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收费编码" prop="chargeNo">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="收费编码" v-model="form.chargeNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="产品用途" prop="productUse">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="产品用途" v-model="form.productUse"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="效益分析" prop="benefitAnalysis">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="效益分析" v-model="form.benefitAnalysis"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="申请理由" prop="reason">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="申请理由" v-model="form.reason"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="科主任意见" prop="directorIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="科主任意见" v-model="form.directorIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="医务科意见" prop="medicalDeptIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="医务科意见" v-model="form.medicalDeptIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="物价部门意见" prop="priceDeptIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="物价部门意见" v-model="form.priceDeptIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="医保部门意见" prop="medicalInsuranceDeptIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="如果有医保代码，请填写医保代码；如果无医保代码，请填写暂无医保代码" v-model="form.medicalInsuranceDeptIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="设备科意见" prop="deviceDeptIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="设备科意见" v-model="form.deviceDeptIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="采购部门意见" prop="purchaseDeptIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="采购部门意见" v-model="form.purchaseDeptIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="分管领导意见" prop="leadIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="分管领导意见" v-model="form.leadIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="院长意见" prop="deanIdea">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="院长意见" v-model="form.deanIdea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode && !showWorkFlowInfo" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <el-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</el-button>
      <el-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</el-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InStockScan from '@/mixin/inStockScan-mixin'
import {

  GetPurchaseDistributionById,
  GetChooseProductById,
  SaveChooseProduct,
  RejectChooseProduct,
} from "@/api";
import { ChooseProductOptions, WhetherOptions } from "@/enum";
// import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InStockScan],
  components: {
    // SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetChooseProductById,
      SaveDataAction: SaveChooseProduct,
      WhetherOptions: WhetherOptions,
      reject: RejectChooseProduct,
      form: {},
      ChooseProductOptions: ChooseProductOptions,
      rules: {
        productName: [
          { required: true, message: '请输入产品名称', trigger: 'blur' }
        ],
        date: [
          { required: true, message: '请选择申报日期', trigger: 'blur' }
        ],
        specName: [
          { required: true, message: '请输入规格型号', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请选择申请人', trigger: 'blur' }
        ],
        deptName: [
          { required: true, message: '请选择申请科室', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        isNewTechnique: [
          { required: true, message: '请选择是否涉及新技术', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择申请类型', trigger: 'blur' }
        ],
        price: [
          { required: true, message: "请输入预计单价", trigger: "blur" },
        ],
        number: [
          { required: true, message: "数量不能为空", trigger: "blur" },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ]
      },
      editMode: false,
      showWorkFlowInfo: false,
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.getUsers("");
    this.getDepts("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })   .finally(() => {
            this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        number: 0,
        amount: 0,
        // isNewTechnique: 1,
        // isCharge: 1,
        // type: 0,
        remark: "",
        phone: "",
        deptName: "",
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        userName: this.userInfo.name,
        deptName: this.userInfo.deptName,
        userId: this.userInfo.id,
        deptId: this.userInfo.deptId,
        phone: this.userInfo.phone,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    applyUserChange (val) {
      this.form.UserId = val;
      let item = this.STATIC_Users.find((e) => e.id == val);
      console.log(item, "item")
      if (item) {
        this.form.deptId = item.deptId;
        this.form.deptName = item.deptName;
        this.form.phone = item.phone;
      }
    },
    applyDeptChange (val) {
      this.form.deptId = val;
    },
    autoAmount () {
      this.form.amount = (this.form.number * this.form.price).toFixed(4) * 1;
    },

  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
